import BaseApiService from './BaseApiService'

class AgentService extends BaseApiService {
   constructor() {
      super()
   }

   async getHierarchies(payload) {
      return await super.execute('post', `agent/hier`, payload)
   }

   async getHierarchiesFromAcb(payload) {
      return await super.execute('post','agent/hierFromAcb',payload)
   }

   async getTree(payload) {
      return await super.execute('post', `agent/tree`, payload)
   }

   async getTreeChildren(payload) {
      return await super.execute('post', `agent/more`, payload)
   }

   async searchDownline(payload) {
      return await super.execute('post', `agent/search`, payload)
   }

   async getDeactivated(payload) {
      return await super.execute('post', `agent/inactive`, payload)
   }

   async getDetail(payload) {
      return await super.execute('post', `agent/detail`, payload)
   }

   async getDocuments(guid) {
      return await super.execute('get', `agent/docs/${guid}`)
   }

   async getList(code) {
      return await super.execute('get', `list/${code}`)
   }

   async sendRequest(payload) {
      return await super.execute('post', `corr/svcreq`, payload)
   }

   async getAgentDetails(payload) {
      return await super.execute('post','agent/mddetail', payload)
   }

   async getPrincipalAgent(payload) {
      return await super.execute(`post`, 'agent/getPrincipalAgent', payload)
   }

   async getBlockNumbers() {
      return await super.execute('get', 'agent/getBlockNumbers')
   }
}

export let agentApi = new AgentService()
